import { UnhandledBankPaymentsActionTypes } from "models/actionTypes/unhandledBankPaymentsActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const unhandledBankPaymentsUpdated = (
  unhandledBankPayments: WintSuperkollAPIModel.BankPaymentInformation
): UnhandledBankPaymentsActionTypes => {
  return {
    type: ReduxConstants.UnhandledBankPaymentsActions.UNHANDLED_BANK_PAYMENTS_REPORT_UPDATED,
    payload: unhandledBankPayments,
  };
};

export const unhandledBankPaymentsCompleted = (id: number): UnhandledBankPaymentsActionTypes => {
  return {
    type: ReduxConstants.UnhandledBankPaymentsActions.UNHANDLED_BANK_PAYMENTS_REPORT_COMPLETED,
    payload: id,
  };
};
